module.exports = __webpack_public_path__ + "static/media/ic_valued_red.f4b3a4f1.svg";